import * as React from 'react';

import { MAX_DISPLAY_FUTURE_MAP_ONBOARDING_COUNT } from '../../../constants/map';
import { useApplicationContext } from '../../../containers/ApplicationContext';
import { getFutureMapOnboardingViews, getIsFutureMapOnboardingEnabled, setFutureMapOnboardingViews } from '../utils';

export function useFutureMapOnboarding() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [timesShown, setTimesShown] = React.useState(0);
  const { config } = useApplicationContext();

  React.useEffect(() => {
    const displayCount = getFutureMapOnboardingViews();
    const isFutureMapOnboardingEnabled = getIsFutureMapOnboardingEnabled(config);

    if (isFutureMapOnboardingEnabled && displayCount < MAX_DISPLAY_FUTURE_MAP_ONBOARDING_COUNT) {
      setIsOpen(true);
      setTimesShown(displayCount);
    }
  }, [config]);

  const closeFutureMapOnboarding = React.useCallback(() => {
    setIsOpen(false);
    setFutureMapOnboardingViews(MAX_DISPLAY_FUTURE_MAP_ONBOARDING_COUNT);
  }, []);

  const handleFutureMapOnboardingShowing = React.useCallback(() => {
    setFutureMapOnboardingViews(timesShown + 1);
  }, [timesShown]);

  return {
    isFutureMapOnboardingOpen: isOpen,
    closeFutureMapOnboarding,
    handleFutureMapOnboardingShowing,
  };
}
